import { render, staticRenderFns } from "./categ_translate.vue?vue&type=template&id=fa9494f2&scoped=true&"
import script from "./categ_translate.vue?vue&type=script&lang=js&"
export * from "./categ_translate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9494f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa9494f2')) {
      api.createRecord('fa9494f2', component.options)
    } else {
      api.reload('fa9494f2', component.options)
    }
    module.hot.accept("./categ_translate.vue?vue&type=template&id=fa9494f2&scoped=true&", function () {
      api.rerender('fa9494f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_translate.vue"
export default component.exports